import { type AudiCalculationModuleSpecsFragment } from '../../../../api/fragments/AudiCalculationModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import { AudiCalculationSettingsEmptyList, AudiCalculationSettingsTable } from './AudiCalculationSetting';

type AudiCalculationModuleTabMainProps = {
    module: AudiCalculationModuleSpecsFragment;
    openAudiCalculationSettingDrawer: () => void;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const AudiCalculationModuleTabMain = ({
    module,
    openAudiCalculationSettingDrawer,
    permissions,
}: AudiCalculationModuleTabMainProps) => {
    if (module.audiCalculationSettings.length === 0) {
        return (
            <AudiCalculationSettingsEmptyList
                openAudiCalculationSettingDrawer={openAudiCalculationSettingDrawer}
                permissions={permissions}
            />
        );
    }

    return <AudiCalculationSettingsTable module={module} />;
};

export default AudiCalculationModuleTabMain;
